import { SportsEnum } from 'types/generated/client';
import CoachGrid from './CoachGrid';
import { CoachType } from './props';

interface SingleCoachSectionProps {
  coaches: CoachType[];
  listHoveredCoachId: string | null;
  setListHoveredCoachId: (id: string | null) => void;
  activeSport: SportsEnum;
  vairProMap: Record<string, boolean>;
}

const SingleCoachSection: React.FC<SingleCoachSectionProps> = ({
  coaches,
  listHoveredCoachId,
  setListHoveredCoachId,
  activeSport,
  vairProMap,
}) => {
  if (coaches.length === 0) {
    return null;
  }

  return (
    <div className="pb-8">
      <CoachGrid
        coaches={coaches}
        listHoveredCoachId={listHoveredCoachId}
        setListHoveredCoachId={setListHoveredCoachId}
        activeSport={activeSport}
        vairProMap={vairProMap}
      />
    </div>
  );
};

export default SingleCoachSection;
